import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_CAST_CREW_HEADING]: 'Cast and Crew',
}